import { brandCss, type Brand } from './resolve-brand';

/** Cópia da marca que o script inline do `index.html` aplica antes do primeiro paint. */
export const BRAND_CACHE_KEY = 'uyzy.brand.v1';

interface BrandCache {
  readonly source: string;
  readonly slug: string | undefined;
  readonly css: string;
  readonly title: string;
  readonly favicon: string | undefined;
}

function setLink(rel: string, href: string) {
  let link = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement('link');
    link.rel = rel;
    document.head.append(link);
  }
  link.href = href;
}

/** Aplica a marca no documento (CSS vars, título, favicon) e guarda para a próxima visita. */
export function applyBrand(brand: Brand, source: string, options: { persist?: boolean } = {}) {
  const doc = document;
  const root = doc.documentElement;
  const css = brandCss(brand);
  let style = doc.getElementById('uyzy-brand');
  if (css) {
    if (!style) {
      style = doc.createElement('style');
      style.id = 'uyzy-brand';
      doc.head.append(style);
    }
    style.textContent = css;
    root.dataset['brand'] = brand.slug ?? 'corban';
  } else {
    style?.remove();
    delete root.dataset['brand'];
  }
  doc.title = brand.name;
  if (brand.favicon) {
    setLink('icon', brand.favicon);
    setLink('apple-touch-icon', brand.favicon);
  }
  if (options.persist === false) return;
  const cache: BrandCache = { source, slug: brand.slug, css, title: brand.name, favicon: brand.favicon };
  try {
    localStorage.setItem(BRAND_CACHE_KEY, JSON.stringify(cache));
  } catch {
    /* sem armazenamento: a marca vale só nesta aba */
  }
  if (import.meta.env.DEV) for (const w of brand.warnings) console.warn(`[marca] ${w}`);
}
